import request from '@/utils/httpRequest'

export default class QualityRectifyService {
  queryQualityRectifyById(id) {
    return request({
      url: '/quality/wuyeQualityRectify/queryById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow(params) {
    return request({
      url: '/quality/wuyeQualityRectify/startFlow',
      method: 'post',
      data: params
    })
  }
}
